export default __webpack_public_path__ + "static/media/guarani.8393f943.svg";